export default __webpack_public_path__ + "static/media/pantry2-after2-2048w.7c8e2f53.png";